<template>
  <header
    class="pt-nav hero-job relative grid grid-cols-3 overflow-hidden bg-amber-100 pl-4 pb-4 sm:pl-20 md:min-h-[75vh]"
  >
    <!-- TITLE -->
    <div class="order-1 col-span-3 sm:col-span-2">
      <h1
        class="hyphens-auto mt-12 max-w-[16ch] text-2xl font-medium sm:mt-20 md:text-7xl"
      >
        {{ data.title }}
      </h1>
    </div>

    <!-- Lottie -->
    <div
      class="order-3 col-span-3 sm:order-2 sm:col-span-1 sm:-mb-40 md:-mr-32 md:-mt-5"
    >
      <!-- Placeholder for the coming Lottie Animation -->
      <div v-if="data.file.extension === 'json'" class="relative">
        <ClientOnly>
          <Vue3Lottie
            :animation-link="data.file.url"
            class="pointer-events-none"
          />
        </ClientOnly>
      </div>
    </div>

    <!-- TEXT -->
    <div
      class="order-2 col-span-3 mx-auto max-w-3xl py-10 pr-4 sm:order-3 sm:pr-20 sm:pb-16 md:pr-0 xl:pt-14 2xl:pt-4"
    >
      <table>
        <tbody>
          <tr
            v-for="(item, index) in data.items"
            :key="index"
            class="border-none bg-amber-100"
          >
            <td
              v-if="item.title && item.text"
              class="flex items-start justify-end bg-amber-100 pr-5 text-xs md:justify-end md:pr-8"
              :class="[
                index === 2 && data.items.length === 3
                  ? 'pt-4 md:pt-10'
                  : 'pt-1.5 md:pt-4',
              ]"
            >
              {{ item.title }}
            </td>
            <td
              v-if="item.title && item.text"
              class="text-[1.625rem] md:text-2xl"
              :class="[
                index === 2 && data.items.length === 3 ? 'pt-3 md:pt-6' : '',
              ]"
            >
              <div class="description leading-tight" v-html="item.text" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </header>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
.hero-job {
  .description {
    a {
      @apply text-blue-500 green:text-green-500 green:outline-pink-500 pink:text-pink-500 underline-offset-4 underline;
    }
  }
}
</style>
